module.exports = __webpack_public_path__ + "img/fixed.cd5fecf8.svg";